exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "flight-member {\n  width: 100%;\n  font-size: small; }\n  flight-member .ui-g-1, flight-member .ui-g-2, flight-member .ui-g-3, flight-member .ui-g-4, flight-member .ui-g-5, flight-member .ui-g-6, flight-member .ui-g-7, flight-member .ui-g-8, flight-member .ui-g-9, flight-member .ui-g-10, flight-member .ui-g-11, flight-member .ui-g-12 {\n    padding: 3px;\n    vertical-align: middle; }\n  flight-member .player-image img {\n    height: 2rem;\n    width: 2rem;\n    border-radius: 50%;\n    -o-object-fit: cover;\n       object-fit: cover; }\n  flight-member .player-name {\n    white-space: normal; }\n    flight-member .player-name.withdrawn {\n      color: red; }\n    flight-member .player-name.clickable:hover {\n      text-decoration: underline;\n      font-weight: bold;\n      cursor: hand;\n      cursor: pointer; }\n  flight-member .player-handicap {\n    text-align: right; }\n  flight-member .player-buggy {\n    text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/flight-member/flight-member.component.scss
// module id = ../../../../../src/app/component-module/flight-member/flight-member.component.scss
// module chunks = main